document.addEventListener('DOMContentLoaded', function(){

	const cartList = document.querySelector('.cart__item-list'),
				cartItemsPrice = document.querySelector('.cart__total-line-items'),
				cartTotal = document.querySelector('.cart__total-line-total'),
				cartSale = document.querySelector('.cart__total-line-sale'),
				totalCount = document.getElementById('headerCount');

	const cart = {
		items : [],
		sale: 0,
		getCart() {

			fetch('/data/cart.json', {
				method: 'get',
			})
				.then(resp => {
					if (!resp.ok) {
						throw new Error(resp.status);
					} else {
						return resp.json();
					}
				})
				.then(data => {
					this.items = data.items;

					if (data.items.length) {
						totalCount.textContent = data.items.length;

						this.sale = data.sale;
						cartSale.textContent = data.sale + ' ₽';

						this.renderCart();
					} else {
						document.querySelector('.cart__header--loading').textContent = cartList.dataset.emptyText;
					}
				})
				.catch(err => {
					console.error('An error occured: ' + err);
				});
		},
		renderItem(item) {
			let options = '';
			for (let i=1; i<(item.max+1); i++) {
				if (i == item.count) {
					options += '<option selected value="' + i + '">' + i + '</option>';
				} else {
					options += '<option value="' + i + '">' + i + '</option>';
				}
			}

			const itemHtml = `
				<li class="cart__item ci" data-id="${item.id}">
					<a class="ci__photo-wrp" href="${item.href}">
						<img class="ci__photo" src="${item.img}" alt="">
					</a>
					<div class="ci__content">
						<div class="ci__top">
							<p class="ci__type">${item.type}</p>
							<a class="ci__header" href="${item.href}">${item.name}</a>
						</div>
						<div class="ci__bottom-lg">
							<ul class="ci__params">${item.descr}</ul>
							<div class="ci__bottom">
								<div class="ci__price-wrp">
									<p class="ci__price">${item.price} ₽</p>
									<div class="ci__select-wrp select">
										<select class="ci__select select__select" name="count">${options}</select>
									</div>
								</div>
								<button class="ci__remove-btn" type="button" title="Удалить товар" aria-label="Удалить товар">
									<svg>
										<use xlink:href="/img/icons.svg#trash"></use>
									</svg>
								</button>
							</div>
						</div>
					</div>
				</li>
			`;

			cartList.insertAdjacentHTML('beforeend', itemHtml);
		},
		renderCart() {
			this.items.forEach(function(item){
				cart.renderItem(item);
			});
			
			document.querySelector('.cart__header--loading').remove();
			document.querySelector('.cart').classList.remove('cart--loading');
			this.countTotalPrice();
		},
		countTotalPrice() {
			const totalPrice = this.items.reduce((sum, item) => {
				return sum + item.price * item.count;
			}, 0);

			cartItemsPrice.textContent = totalPrice + ' ₽';
			cartTotal.textContent = totalPrice - this.sale + ' ₽';
		},
		deleteItem(line) {
			let id = line.dataset.id;

			this.items = this.items.filter(item => id !== item.id);
			line.remove();
			this.sendChangeToServer(id, 0);
			

			if (!this.items.length) {
				this.sale = 0;
				this.showEmptyCart();
			}

			this.countTotalPrice();
		},
		changeCount(line, count) {
			
			let id = line.dataset.id;

			for (const item of this.items) {
				if (item.id == id) {
					
					item.count = count;
					this.sendChangeToServer(id, count);

					break;
				}
			}

			this.countTotalPrice();
		},
		showEmptyCart() {
			const page = document.querySelector('.cart');
			page.classList.add('cart--loading');

			const warning = document.createElement('p');
			warning.className = 'cart__header cart__header--loading';
			warning.textContent = cartList.dataset.emptyText;

			document.querySelector('.cart__main-part').append(warning);
		},
		sendChangeToServer(id, count) {
			let data = new FormData();
			data.append('id', id);
			data.append('count', count);
			fetch('/data/cartItemChange.json',{
				method: 'post',
				body: data
			});
		}
	}

	// init
	cart.getCart();

	// count change
	document.addEventListener('change', function(e){
		const target = e.target.closest('.ci__select');
		if (!target) {
			return;
		}

		let line = target.closest('.ci');
		cart.changeCount(line, target.value);
	});

	// delete
	document.addEventListener('click', function(e) {
		const btn = e.target.closest('.ci__remove-btn');

		if (!btn) {
			return;
		}

		cart.deleteItem(btn.closest('.ci'));
	});
});